import { clsx, type ClassValue } from 'clsx';

/**
 * Utility para combinar class names condicionalmente
 * Basado en shadcn/ui
 *
 * @example
 * cn('base-class', condition && 'conditional-class', { 'active': isActive })
 *
 * @param inputs - Array de class names, condiciones, objetos
 * @returns String de class names combinados
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}
